module.exports = __webpack_public_path__ + "assets/a484aa7f1cbabbf02905c4619dd138ef.mp3";